module.exports = __webpack_public_path__ + "static/media/avatar.4b9be9a3.svg";